var exports = {
  "V": "DirectionalIcons.module__mirrored___a2psdW",
};

module.exports = exports;
